// angular
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import { Restaurant, WorkDay} from '../../../../core/models/restaurant.model';
import {RouteService} from '../../../../core/services/route.service';
import { RestaurantStore } from 'src/app/core/stores/restaurant.store';
import {FormatDataService} from '../../../../core/services/format-data.service';
import {GoogleMapService} from '../../../../core/services/google-map.service';

@Component({
  selector: 'app-restaurant-closed-modal',
  templateUrl: './restaurant-closed-modal.component.html',
  styleUrls: [
    './restaurant-closed-modal.component.scss',
    '../../../../shared/components/product-modal/product-modal.component.scss'
  ]
})
export class RestaurantClosedModalComponent implements OnInit {
  @Input() nextOpenTimeUtc: string;
  @Input() isGroup: boolean;
  @Input() restaurant: Restaurant;
  @Input() restaurants: Restaurant[];
  @Input() filteredWorkHours: WorkDay[];
  @Input() restaurantsFilteredWorkHours: WorkDay[][];
  @Output() close = new EventEmitter<boolean>();
  public restaurantClosedSign = './assets/images/restaurant_closed_sign.svg';
  public restaurantPreordersSign = './assets/images/preorders_sign.svg';
  public restaurantPausedSign = './assets/images/restaurant_paused_sign.svg';
  public numberLocations = 0;
  public isShowRestaurantList = false;
  public userPosition: google.maps.LatLngLiteral;
  public center: google.maps.LatLngLiteral;
  public zoom = 15;
  public mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
    streetViewControl: false,
    mapTypeControl: false,
    scaleControl: false,
    fullscreenControl: false,
  };
  public isLocationAddress: boolean = true;

  constructor(
    private router: Router,
    private routeService: RouteService,
    private restaurantStore: RestaurantStore,
    private formatDataService: FormatDataService,
    private googleMapService: GoogleMapService
  ) {
  }

  public get storeOrderingPaused(): boolean {
    if (this.isGroup) {
      return !this.restaurants.find( (restaurant) => restaurant.isMobileEnabled === true);
    }
    return !this.restaurant.isMobileEnabled;
  }

  public get storeOrderingScheduled(): boolean {
    if (this.isGroup) {
      return !!this.restaurants.find( (restaurant) => restaurant.isMobileEnabled && restaurant.allowScheduledPickups === true && this.isRestaurantHaveEnabledWorkDays(restaurant));
    }
    return this.restaurant.isMobileEnabled && this.restaurant.allowScheduledPickups && this.isRestaurantHaveEnabledWorkDays(this.restaurant);
  }

  public get storeClosed(): boolean {
    if (this.isGroup) {
      return !this.restaurants.find( (restaurant) => restaurant.isMobileEnabled && restaurant.allowScheduledPickups === true && this.isRestaurantHaveEnabledWorkDays(restaurant));
    }
    return (this.restaurant.isMobileEnabled && !this.restaurant.allowScheduledPickups) || !this.isRestaurantHaveEnabledWorkDays(this.restaurant);
  }

  public get restaurantWorkDays() {
    return this.filteredWorkHours.map(day => day.dayType.dayType.substr(0,3));
  }

  public get isMultipleLocations(): boolean {
    if (this.numberLocations === 0) {
      this.restaurantStore.restaurants$
      .subscribe(restaurants => {
        this.numberLocations = restaurants.length;
      });
    }
    return this.numberLocations > 1;
  }

  public get restaurantModalSign() {
    if (this.storeOrderingPaused) {
      return this.restaurantPausedSign;
    } else if (this.storeOrderingScheduled) {
      return this.restaurantPreordersSign;
    } else {
      return this.restaurantClosedSign;
    }
  }

  public get isHideSigns(): boolean {
    return this.restaurant.hideAllSigns;
  }

  public get restaurantWorkHours() {
    if (this.filteredWorkHours && this.filteredWorkHours.length > 0) {
      return this.filteredWorkHours.map(day => day.enable ? this.formatDataService.formatWorkDay(day) : `Closed ${day.isBlackouted ? `(${day.blackoutDayName})` : ''}`);
    }
    return this.restaurant.hoursOfOperation.map(day => day.enable ? this.formatDataService.formatWorkDay(day) : 'Closed' );
  }

  ngOnInit() {
    this.getLocationsCoordinates();
  }

  public showRestaurantList(): void {
    this.isShowRestaurantList = !this.isShowRestaurantList;
  }

  public isRestaurantHaveEnabledWorkDays(restaurant: Restaurant): boolean {
    return !!restaurant.hoursOfOperation.find( (day) => day.enable === true);
  }

  public chooseRestaurant(index: number): void {
    this.restaurant = this.restaurants[index];
    this.filteredWorkHours = this.restaurantsFilteredWorkHours[index];

    this.isShowRestaurantList = false;
  }

  public goToHomePage(): void {
    const baseUrl = this.routeService.getBaseUrl();
    this.router.navigate([baseUrl])
      .catch(error => console.log(error));
  }

  public closeModal(): void {
    this.close.emit();
  }

  public get getPhoneIfExists() {
    return this.restaurant.contactPhoneNumber == null ? '' : `: ${this.restaurant.contactPhoneNumber}`;
  }
  private getLocationsCoordinates(): void {
    this.isLocationAddress = !!this.restaurant.address.addressLine;
    const localityQuery = this.restaurant.address.locality && this.restaurant.address.locality.replace(/ /g, '+');
    const addressLineQuery = this.restaurant.address.addressLine && this.restaurant.address.addressLine.replace(/ /g, '+');
    const stateQuery = this.restaurant.address.state && this.restaurant.address.state.replace(/ /g, '+');
    const postalCodeQuery = this.restaurant.address.postalCode;
    const countryQuery = this.restaurant.address.country && this.restaurant.address.country.replace(/ /g, '+');

    const query = [addressLineQuery, localityQuery, stateQuery, postalCodeQuery, countryQuery].filter(Boolean).join(',');
    this.googleMapService.findAddress(query).subscribe(response => {
      if (response.results && response.results.length > 0) {
        const coordinates = {
          lat: response.results[0].geometry.location.lat,
          lng: response.results[0].geometry.location.lng
        };
        this.userPosition = coordinates;
        this.center = coordinates;
      }
    });
  }
}
